<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-briefcase"></i>
    </div>
    <div>
      <h2 class="dialog-title">Edit Office</h2>
      <p class="dialog-subtitle">Fill in the office details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="officeForm" class="dialog-form-grid">
    <!-- Commercial Office -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">Commercial Office <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="commercialOffice" placeholder="Enter commercial office name">
        @if( officeForm.get('commercialOffice')?.hasError('required') ) {
          <mat-error>Commercial Office is required</mat-error>
        }
        @if( officeForm.get('commercialOffice')?.hasError('invalidcharacters') ) {
          <mat-error>Commercial Office contains invalid characters</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- External ID -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">External ID</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="externalId" placeholder="Enter external ID">
        @if( officeForm.get('externalId')?.hasError('required') ) {
          <mat-error>External ID is required</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!officeForm.valid">
    {{(data.id == -1 ? 'Create' : 'Update')}} Office
  </button>
</mat-dialog-actions>
